import React, { useState } from "react";
import SectionHeader from "./SectionHeader";
import { experience } from "../mock";
import { Briefcase, ChevronRight, Building2, CalendarDays } from "lucide-react";

const Experience = () => {
  const [active, setActive] = useState(0);
  const exp = experience[active];

  return (
    <section id="experience" className="relative px-6 lg:px-10 py-20 border-t border-[#1c2533]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          num="03 // OPS HISTORY"
          title="PROFESSIONAL EXPERIENCE"
          subtitle="MONITOR // INVESTIGATE // RESPOND"
        />

        <div className="grid lg:grid-cols-12 gap-4">
          {/* Timeline picker */}
          <div className="lg:col-span-4 space-y-2">
            {experience.map((e, i) => {
              const isActive = active === i;
              return (
                <button
                  key={e.code}
                  onClick={() => setActive(i)}
                  className={`w-full text-left border p-4 transition-all flex items-center gap-3 ${
                    isActive
                      ? "border-cyan-400 bg-[#0c1620]"
                      : "border-[#1c2533] bg-[#0c1118] hover:border-[#2a3a52]"
                  }`}
                >
                  <div
                    className={`w-10 h-10 grid place-items-center border ${
                      isActive
                        ? "border-cyan-400 text-cyan-400"
                        : "border-[#2a3a52] text-slate-300"
                    }`}
                  >
                    <Briefcase size={16} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-mono text-[10px] tracking-[0.18em] text-slate-500">
                      {e.code} &middot; {e.type}
                    </div>
                    <div
                      className={`font-mono text-[12px] tracking-[0.08em] font-semibold truncate ${
                        isActive ? "text-cyan-400" : "text-slate-100"
                      }`}
                    >
                      {e.company}
                    </div>
                    <div className="text-[11px] text-slate-400 truncate">{e.role}</div>
                  </div>
                  <ChevronRight
                    size={16}
                    className={isActive ? "text-cyan-400" : "text-slate-600"}
                  />
                </button>
              );
            })}
          </div>

          {/* Detail */}
          <div className="lg:col-span-8 border border-[#1c2533] bg-[#0c1118] corner-brackets relative">
            <div className="flex items-center justify-between px-5 py-3 border-b border-[#1c2533] bg-[#0a0e14] flex-wrap gap-2">
              <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] text-cyan-400">
                <Building2 size={13} />
                {exp.company}
                <span className="text-slate-700">//</span>
                <span className="text-slate-300">{exp.role}</span>
              </div>
              <div className="flex items-center gap-1.5 font-mono text-[10px] tracking-[0.18em] text-slate-400">
                <CalendarDays size={12} className="text-cyan-400" />
                {exp.period}
              </div>
            </div>

            <div className="p-6">
              <ul className="space-y-2.5">
                {exp.bullets.map((b, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 p-3 border border-[#1c2533] bg-[#0a0e14] hover:border-cyan-400/50 transition-colors"
                  >
                    <span className="font-mono text-cyan-400 text-[11px] tracking-[0.15em] mt-0.5 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-slate-200 text-[13.5px] leading-relaxed">
                      <span className="text-cyan-500/70 mr-2">&rarr;</span>
                      {b}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-5 pt-4 border-t border-[#1c2533]">
                <div className="font-mono text-[10px] tracking-[0.2em] text-slate-500 mb-2">
                  STACK IN ROTATION
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {exp.stack.map((s) => (
                    <span
                      key={s}
                      className="font-mono text-[10.5px] tracking-[0.06em] text-slate-300 bg-[#0a0e14] border border-[#1c2533] px-2 py-1 rounded-sm hover:border-cyan-400 hover:text-cyan-400 transition-colors"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
